import { MapPin, ShoppingBag, Wheat, Coffee, Sparkles } from "lucide-react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
export default function ImportedExcellence() {
  return <section data-section-id="223031" id="imported-excellence" className="dark relative py-24 lg:py-32 bg-background text-foreground overflow-hidden">
      {/* Decorative background glow */}
      <div className="absolute inset-0 pointer-events-none bg-[radial-gradient(circle_at_center,var(--color-secondary)_0%,transparent_100%)] opacity-10" />

      <div className="container relative mx-auto px-4 md:px-6">
        <div className="grid lg:grid-cols-2 gap-16 lg:gap-24 items-center">
          
          {/* Visual Showcase - Layered Icon & Color Composition */}
          <div className="relative w-full max-w-xl mx-auto lg:mx-0 aspect-[4/5] sm:aspect-square lg:aspect-[4/5]">
            {/* Layer 1 - Imported Goods Block */}
            <div className="absolute top-0 left-0 w-[68%] h-[68%] rounded-2xl bg-card border border-border/70 p-6 md:p-8 flex flex-col justify-between shadow-lg">
              <div className="flex items-center justify-between">
                <div className="size-14 rounded-xl bg-secondary/15 text-secondary flex items-center justify-center border border-secondary/20">
                  <ShoppingBag className="size-7" />
                </div>
                <div className="flex items-center gap-1.5 px-2.5 py-1 rounded-md bg-secondary/10 border border-secondary/20 text-xs font-mono tracking-wider text-secondary uppercase">
                  <Sparkles className="size-3" />
                  <span>Curated</span>
                </div>
              </div>
              <div className="space-y-1.5">
                <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground">European Goods</span>
                <p className="font-serif text-2xl text-card-foreground">Artisanal Pantry & Delicacies</p>
              </div>
            </div>

            {/* Layer 2 - Fresh Focaccia & Bakery Block */}
            <div className="absolute bottom-0 right-[3%] w-[64%] h-[64%] rounded-2xl bg-muted/80 border-4 border-background p-6 md:p-8 flex flex-col justify-between shadow-2xl z-10 backdrop-blur-sm">
              <div className="flex items-center justify-between">
                <div className="size-14 rounded-xl bg-primary/20 text-primary flex items-center justify-center border border-primary/30">
                  <Wheat className="size-7" />
                </div>
                <span className="text-xs font-mono uppercase tracking-widest text-primary font-medium">Daily Bake</span>
              </div>
              <div className="space-y-1.5">
                <span className="text-xs font-mono uppercase tracking-widest text-muted-foreground">Oven Traditions</span>
                <p className="font-serif text-2xl text-foreground">Handcrafted Focaccia & Pastries</p>
              </div>
            </div>

            {/* Layer 3 - Coffee & Matcha Ritual Accent Tile */}
            <div className="absolute top-[28%] left-[38%] w-[48%] aspect-square rounded-xl bg-secondary text-secondary-foreground border-4 border-background p-5 flex flex-col items-center justify-center text-center shadow-xl z-20">
              <div className="size-12 rounded-lg bg-secondary-foreground/15 flex items-center justify-center mb-3">
                <Coffee className="size-6 text-secondary-foreground" />
              </div>
              <span className="text-xs font-mono uppercase tracking-widest opacity-80">Morning Ritual</span>
              <p className="font-serif text-xl font-medium mt-1">Matcha & Espresso</p>
            </div>
          </div>

          {/* Text Content */}
          <div className="flex flex-col gap-8">
            <div className="space-y-4">
              <div className="inline-flex items-center gap-2 px-3 py-1.5 rounded-md bg-muted text-muted-foreground text-sm font-default font-medium tracking-[0.1em] uppercase">
                <MapPin className="size-4 text-primary" />
                <span>Modern Heritage</span>
              </div>
              <h2 className="text-4xl md:text-5xl lg:text-6xl font-serif font-medium text-foreground leading-[1.15]">
                Imported Excellence, Local Heart
              </h2>
            </div>

            <div className="space-y-6 text-lg text-muted-foreground font-default tracking-wide leading-relaxed">
              <p>
                M&M Café & Market brings the curated charm of a European grocery to the heart of Enfield. We believe in the beauty of the everyday—where a perfectly pulled espresso meets the artisanal craftsmanship of imported delicacies from Italy, France, and Poland.
              </p>
              <p>
                Our curation process is a labor of love. From the buttery crumb of our morning pastries to the rich textures of our focaccia deli sandwiches, every ingredient is selected for its story and its soul. We bridge the gap between old-world tradition and modern neighborhood warmth.
              </p>
              <p>
                Whether you're here for your daily matcha ritual or exploring our market shelves for that elusive European specialty, you'll find an atmosphere designed for lingering, discovery, and the simple joy of quality.
              </p>
            </div>

            <div className="pt-4">
              <Button asChild size="lg" className="rounded-md bg-primary text-primary-foreground hover:opacity-90 px-8 h-12 text-base transition-all shadow-md">
                <Link to="/StoryPage">
                  Our Story
                </Link>
              </Button>
            </div>
          </div>

        </div>
      </div>
    </section>;
}